var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CompanyObjectRefSelect',{attrs:{"options":_vm.companyFilterOptions,"mode":_vm.mode,"object-type":"company_filter","placeholder":"Filter","external-path":"/definitions","external-query":{
    tab: 'filters',
  }},model:{value:(_vm.vModel),callback:function ($$v) {_vm.vModel=$$v},expression:"vModel"}})
}
var staticRenderFns = []

export { render, staticRenderFns }